'use strict';

var jsxRuntime = require('react/jsx-runtime');
require('../../../_virtual/_tslib.js');
require('tailwind-merge');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');

const FullModalContainer = ({ children })=>{
    return jsxRuntime.jsx(Box, {
        "data-testid": "design-system--full-modal-container",
        className: "h-dvh w-dvw overflow-auto bg-w-white",
        children: children
    });
};

module.exports = FullModalContainer;
